import { useState } from "react";
import { Download, FileText, FileSpreadsheet, Folder, Table2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { toast } from "sonner";
import axios from "axios";

import { API_URL } from "@/lib/api";
const API = `${API_URL}/api`;

const LocalExportReport = ({ localId, dataType, count, filters, searchTerm, onOpenExplorer }) => {
  const [generating, setGenerating] = useState(false);

  const generateReport = async (format) => {
    if (count === 0) { toast.error("No hay datos para exportar"); return; }
    setGenerating(true);
    toast.info(`Generando ${format.toUpperCase()}...`);
    try {
      const params = new URLSearchParams({ format, data_type: dataType });
      if (searchTerm) params.append("search", searchTerm);
      if (filters?.familia && filters.familia !== "__all__") params.append("familia", filters.familia);
      if (filters?.subfamilia && filters.subfamilia !== "__all__") params.append("subfamilia", filters.subfamilia);
      if (filters?.loteMin && filters.loteMin !== "__all__") params.append("lote_inicio", filters.loteMin);
      if (filters?.loteMax && filters.loteMax !== "__all__") params.append("lote_final", filters.loteMax);
      if (filters?.stockMin) params.append("stock_min", filters.stockMin);
      if (filters?.stockMax && filters.stockMax < 999999) params.append("stock_max", filters.stockMax);

      const response = await axios.post(`${API}/local/${localId}/reports/generate?${params.toString()}`);
      toast.success(`Reporte generado: ${response.data.filename} (${response.data.products_count} registros)`);
      if (onOpenExplorer) onOpenExplorer();
    } catch (error) {
      toast.error(error.response?.data?.detail || `Error al generar el ${format.toUpperCase()}`);
    } finally {
      setGenerating(false);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" disabled={count === 0 || generating}
            className="body-font border-sky-600 text-sky-700 hover:bg-sky-50 text-xs h-7"
            data-testid="local-export-report-btn">
            {generating ? (
              <><div className="w-3 h-3 border-2 border-sky-600 border-t-transparent rounded-full animate-spin mr-1.5" />Generando...</>
            ) : (
              <><Download className="w-3 h-3 mr-1.5" />Descargar Reporte ({count})</>
            )}
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="w-44">
          <DropdownMenuItem onClick={() => generateReport("pdf")} className="cursor-pointer" data-testid="local-export-pdf">
            <FileText className="w-4 h-4 mr-2 text-rose-600" />
            <span className="text-xs">Generar PDF</span>
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => generateReport("xlsx")} className="cursor-pointer" data-testid="local-export-xlsx">
            <Table2 className="w-4 h-4 mr-2 text-sky-600" />
            <span className="text-xs">Generar Excel</span>
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => generateReport("csv")} className="cursor-pointer" data-testid="local-export-csv">
            <FileSpreadsheet className="w-4 h-4 mr-2 text-emerald-600" />
            <span className="text-xs">Generar CSV</span>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      {onOpenExplorer && (
        <Button variant="outline" size="sm" onClick={onOpenExplorer}
          className="body-font border-slate-300 text-slate-600 hover:bg-slate-50 text-xs h-7"
          data-testid="local-open-reports-btn">
          <Folder className="w-3 h-3 mr-1.5 text-sky-500" />Ver Reportes
        </Button>
      )}
    </div>
  );
};

export default LocalExportReport;
